import logo from '../../assets/rulestore_logo_large.png';

export default function ProductWordmark() {
    return (
        <div className="auth-wordmark" aria-label="RuleStore">
            <img src={logo} alt="RuleStore" />
        </div>
    );
}
